import React, { Component } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, RefreshCw, MessageSquare, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useLanguage } from '../hooks/useLanguage';
import { useCountry } from '../hooks/useCountry';
export function PaymentFailedPage() {
  const {
    language
  } = useLanguage();
  const {
    whatsappNumber
  } = useCountry();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isRTL = language === 'ar';
  // Get error details if available
  const errorMessage = searchParams.get('message') || searchParams.get('error');
  const handleContactSupport = () => {
    const message = isRTL ? 'مرحباً، واجهت مشكلة في الدفع على منصة Operines.' : 'Hello, I encountered a payment issue on Operines platform.';
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-2556">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden border border-gray-100" data-id="element-2557">
        {/* Header */}
        <div className="bg-red-50 p-8 text-center border-b border-red-100" data-id="element-2558">
          <motion.div initial={{
          scale: 0,
          rotate: -45
        }} animate={{
          scale: 1,
          rotate: 0
        }} transition={{
          type: 'spring',
          delay: 0.2
        }} className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2559">
            <XCircle className="w-10 h-10 text-red-600" data-id="element-2560" />
          </motion.div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-2561">
            {isRTL ? 'فشل الدفع' : 'Payment Failed'}
          </h1>
          <p className="text-gray-600" data-id="element-2562">
            {isRTL ? 'عذراً، لم نتمكن من إتمام عملية الدفع. يرجى المحاولة مرة أخرى أو التواصل معنا.' : "Sorry, we couldn't process your payment. Please try again or contact support."}
          </p>
        </div>

        {/* Error Details */}
        <div className="p-6 space-y-6" data-id="element-2563">
          {errorMessage && <div className="bg-red-50 border border-red-100 rounded-lg p-4 flex items-start gap-3" data-id="element-2564">
              <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-2565" />
              <p className="text-sm text-red-700" data-id="element-2566">{errorMessage}</p>
            </div>}

          <div className="space-y-3" data-id="element-2567">
            <Button fullWidth onClick={() => navigate('/subscription')} className="bg-[#4f1964] hover:bg-[#3d1350] text-white" data-id="element-2568">
              <RefreshCw className={isRTL ? 'ml-2 w-4 h-4' : 'mr-2 w-4 h-4'} data-id="element-2569" />
              {isRTL ? 'حاول مرة أخرى' : 'Try Again'}
            </Button>

            <Button fullWidth variant="outline" onClick={handleContactSupport} className="border-gray-200 text-gray-600 hover:bg-gray-50" data-id="element-2570">
              <MessageSquare className={isRTL ? 'ml-2 w-4 h-4' : 'mr-2 w-4 h-4'} data-id="element-2571" />
              {isRTL ? 'تواصل مع الدعم' : 'Contact Support'}
            </Button>
          </div>

          <div className="text-center" data-id="element-2572">
            <button onClick={() => navigate('/dashboard')} className="text-sm text-gray-500 hover:text-gray-700 underline" data-id="element-2573">
              {isRTL ? 'العودة للوحة التحكم' : 'Back to Dashboard'}
            </button>
          </div>
        </div>
      </motion.div>
    </div>;
}